module.exports = __webpack_public_path__ + "static/media/ringoutdou.92a77e07.mp3";